<template>
    <div class="td-banner danger slim mb-2">
        <icon name="faTriangleExclamation" type="solid"></icon>
        <p>{{error}}</p>
    </div>
</template>

<script>import script from './Error';
    export default script;</script>
